import React, { useState, useEffect, createContext } from 'react';
import { auth } from '../firebase/firebase';
import { getUserDocRef } from '../firebase/adminUser';
import { signIn } from '../firebase/signIn';
import { signOut } from '../firebase/signOut';


export const UserContext = createContext({
  initializing: true,
  user: null,
  resetUser: () => { },
});

function UserProvider({ children }) {
  const [initializing, setInitializing] = useState(true);
  const [user, setUser] = useState(undefined);

  const resetUser = () => {
    setUser(null);
  };

  useEffect(() => {
    if (typeof user !== 'undefined' && initializing) {
      setInitializing(false);
    }
  }, [user, initializing]);

  useEffect(() => {

    let unsubscribeFromUser = null;
    const unsubscribeFromAuth = auth.onAuthStateChanged(userAuth => {


      (async () => {

        if (userAuth) {
          const userRef = await getUserDocRef(userAuth);
          if (!userRef) {
            await signOut();
          }
          else {
            unsubscribeFromUser = userRef.onSnapshot((snapshot) => {
              if (snapshot && snapshot.data()) {
                const data = snapshot.data();
                let role = null;
                if (typeof data.accessLevel === 'number') {
                  switch (data.accessLevel) {
                    case 10:
                      role = "Owner";
                      break;
                    case 20:
                      role = "Admin";
                      break;
                    case 30:
                      role = "Editor";
                      break;
                    default:
                      role = "Användare";
                  }
                }
                setUser({ uid: snapshot.id, ...data, role: role })
              }
            });
          }
        } else {
          setUser(null);
          unsubscribeFromUser && unsubscribeFromUser();
        }

      })();

      // setUser(userAuth);

    });
    return () => {
      unsubscribeFromUser && unsubscribeFromUser();
      unsubscribeFromAuth();
    }
  }, []);

  return (
    <UserContext.Provider value={{ initializing, user, resetUser }}>{children}</UserContext.Provider>
  );

}

export default UserProvider;